import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export const AppLayout = () => {
  const { pathname } = useLocation();
  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <Topbar pathname={pathname} />
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
